import React, { useState, useEffect, memo } from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom';
import {ServerConfig} from 'config'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../redux/actions/auth.js'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid, Hidden, Container, Modal, Button, Box } from '@material-ui/core'
import { ListGroup, ListGroupItem, Table } from 'reactstrap';

import Form from 'react-bootstrap/Form'

import Page from 'components/Page/Page'
import { getAllowedRoutes } from 'utils';
import _, { get } from 'lodash'


const useStyles = makeStyles((theme) => ({
    container: {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(12)
    }
  },
  listItem: {
    fontSize:'15px',
    listStyle:'none',
    margin:0,
    padding:0
  },
  listGroup: {
    margin:0,
    padding:0,
    marginBottom:20,
  },
    label: {
        display:'block',
        width:200
    },
}))

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const MAX_CHARS = 160;

const Messaging = () => {
  const [status, setStatus] = useState({ kind: "idle", message: "" }); 
  const [body, setBody] = useState("");

  console.log("[PublicRelationsPage] Loading!")
  const auth = useSelector(state => state.auth)
  const classes = useStyles()
  const dispatch = useDispatch();
  
  useEffect(() => {}, [])

  if(!auth.access_token){
    return <Redirect to="/login" />
  }

  const handleBodyChange = (event) => {
    const value = event.target.value;

    if (value.length === 0) {
      setBody("");
      setStatus({ kind: "idle", message: "" });
      return;
    }

    if (value.length <= MAX_CHARS) {
      setBody(value);
      setStatus({ kind: "info", message:  `${MAX_CHARS - body.length - 1} chars left` });
    }
  };

    const handleSubmit = async (event) => {
      event.preventDefault();
      // Frontend validation: no empty messages
      if (!body.trim()) {
        setStatus({ kind: "error", message: "Please enter a message before sending." });
        return;
      }

      const config = {headers:{'Content-Type':'application/json'}}

      if(auth.access_token){
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

        const data = new FormData(event.target);
        const value = Object.fromEntries(data.entries());
        
        await axios.post(`${ServerConfig.SERVER_URL}/admin/send_bulk_sms`, value, config)
        .then(() => {
            setStatus({ kind: "success", message: "Sent ("+Date().toLocaleString()+")" });
            setBody("");
        })
        .catch(() => {
          setStatus({ kind: "error", message: "Server error ("+Date().toLocaleString()+")" }); 
        });
    }

    return (
            <>
                <Typography variant="h2">SMS</Typography>
                <Typography variant="h6">WARNING! This will send a SMS to <b>all</b> customers!</Typography>
                <form onSubmit={handleSubmit}>
                    <div className="form-group" style={{'float':'left', 'margin':'10px'}}>
                        <label htmlFor="body" style={{'display':'block','width':150+"px"}}>Message</label>
                        <textarea className="form-control" name="body" value={body} id="body" onChange={handleBodyChange} style={{'width':'400px', 'height':'300px'}}></textarea>
                    </div>
                    <br style={{'clear':'both'}}/>
                    <Button type='submit' style={{'margin':'10px', 'display':'block', 'float':'left'}}>Send</Button>
                    <Typography id="details_status" variant="h6" component="h2" style={{ 'lineHeight': '36px', 'padding': '10px' }}>
                      {status.kind == "error" ? (<span style={{ color: 'red' }}>ERROR: {status.message}</span>) : status.message}
                      {/* {body.length > 0 && `${charsLeft} chars left`} */}
                    </Typography>
                </form>
            </>
            )
}

export default Messaging
